import styled from 'styled-components/macro';

import { Link } from 'components/blueprint';

export const StyledLink = styled(Link)`
  && {
    :hover,
    :focus {
      text-decoration: none;
    }
  }
`;
